export class CoreEntity {
    public static Project = 'PROJECT';
    public static Activity = 'ACTIVITY';
    public static Focal = 'FOCAL';
    public static ActivityWork = 'ACTIVITY_WORK';
    public static Opportunity = 'OPPORTUNITY'
    public static Impediment = 'IMPEDIMENT'
}
